import { render, staticRenderFns } from "./LPPunchPlates.vue?vue&type=template&id=33141de7&scoped=true"
import script from "./LPPunchPlates.vue?vue&type=script&lang=js"
export * from "./LPPunchPlates.vue?vue&type=script&lang=js"
import style0 from "./LPPunchPlates.vue?vue&type=style&index=0&id=33141de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33141de7",
  null
  
)

export default component.exports